import {panel, clearfix, absCenterY, colors} from '@xpertdox_js/xdstyle';

export default {
    container: {
        background: '#fff',
        minHeight: '100%',
    },
    editPanel: {
        padding: 10,
        width: '100%',
        minHeight: '100%',
        fontSize: '1.2rem',
    },
}
